import { getVisitorServiceUrl } from "@/Services/base-url/api-constants";
import $ from "jquery";
import { hasVisitTrackingCookie } from "./cookieIdentity";

const VISITOR_POLL_MS = 100;
const VISITOR_READY_TIMEOUT_MS = 3000;

declare global {
  interface Window {
    __visitorLoaded?: boolean;
    $?: typeof $;
    jQuery?: typeof $;
  }
}

/** Injects visitor.js once — mirrors WriteSimpli App.tsx bootstrap. */
export function loadVisitorScript(): void {
  if (typeof window === "undefined") return;
  if (window.__visitorLoaded) return;

  window.__visitorLoaded = true;
  window.$ = $;
  window.jQuery = $;

  const script = document.createElement("script");
  script.src = getVisitorServiceUrl("");
  script.async = true;
  document.body.appendChild(script);
}

/**
 * Waits briefly for visitor.js to set visitGuid before operation-limit calls.
 * Returns true when a visit cookie exists, false after timeout.
 */
export async function ensureVisitorCookiesReady(
  timeoutMs = VISITOR_READY_TIMEOUT_MS,
): Promise<boolean> {
  loadVisitorScript();

  if (hasVisitTrackingCookie()) {
    return true;
  }

  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, VISITOR_POLL_MS));
    if (hasVisitTrackingCookie()) {
      return true;
    }
  }

  return hasVisitTrackingCookie();
}
